import { render, staticRenderFns } from "./rule-datatable.component.vue?vue&type=template&id=5e2ed360&scoped=true&"
import script from "./rule-datatable.component.vue?vue&type=script&lang=ts&"
export * from "./rule-datatable.component.vue?vue&type=script&lang=ts&"
import style0 from "./rule-datatable.component.vue?vue&type=style&index=0&id=5e2ed360&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2ed360",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VChip,VDataTable,VExpandTransition,VIcon,VSpacer})
